<template>
  <div class="member-login">
    <v-app-bar app flat color="transparent" dense :class="['header', 'primaryText--text']">
      <v-row>
        <v-col cols="3" class="d-flex">
          <v-app-bar-nav-icon v-show="showBackButton" @click="navBack">
            <v-icon color="black">mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="6" class="d-flex justify-center"> </v-col>

        <v-col cols="3" align-self="end" style="text-align: right"> </v-col>
      </v-row>
    </v-app-bar>

    <v-container>
      <v-img :src="companyLogoSrc" @error="defaultLogo = true" contain height="150" width="150" class="company-logo" />
      <v-form v-model="valid" ref="form" v-on:submit.prevent>
        <v-container>
          <v-list-item>
            <v-text-field
              v-model="phone"
              :rules="[inputRules.required, inputRules.phone]"
              :label="$t('mobile_no')"
              :placeholder="$t('login_with_mobile')"
              required
            ></v-text-field>
          </v-list-item>

          <div class="text-center mt-2 px-4 font-weight-light">
            {{ $t("sms_receive_vcode") }}
          </div>

          <v-btn class="horizontal-center login-button" :disabled="!valid" @click="login">{{ $t("login") }}</v-btn>
        </v-container>
      </v-form>
    </v-container>

    <v-footer id="login-footer" fixed class="d-flex justify-center" color="transparent"
      ><div v-show="footerVisible" @click="openMRSWebPage" class="powered-by-mrs">
        <div class="powered-by">Powered by</div>
        <v-img src="@/assets/imgs/logo-mrs.png" width="80"></v-img>
      </div>
    </v-footer>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  components: {},

  data: () => ({
    valid: false,
    refreshing: false,
    phone: "",

    defaultLogo: false,
    footerTop: 0,
    footerVisible: true,

    clientHeight: 0,
    clientHeight2: 0,

    nextRouteName: null,
  }),

  created() {
    console.log("Login created");

    this.clientHeight = document.documentElement.clientHeight;

    // hide the footer in virtual keyboard shown
    window.addEventListener("resize", () => {
      let n_clientHeight = document.documentElement.clientHeight;

      let ele = document.getElementById("login-footer");
      if (ele != null) {
        this.clientHeight = Math.max(this.clientHeight, n_clientHeight);
        this.footerVisible = this.clientHeight - n_clientHeight < 10;
      }
    });
  },

  activated() {
    console.log("Login activated");
    console.log("Login route from", this.$store.state.routeFrom);
    console.log("Login params", this.$route.params);

    this.nextRouteName = null;
    if (this.$route.params.nextRouteName != null) this.nextRouteName = this.$route.params.nextRouteName;

    this.phone = "";
  },

  mounted() {},

  destroyed() {},

  computed: {
    companyLogoSrc() {
      return this.defaultLogo || this.$store.state.appLogoSrc == null || this.$store.state.appLogoSrc == ""
        ? require("@/assets/imgs/login-logo.png")
        : this.$store.state.appLogoSrc;
    },

    showBackButton() {
      return !this.$loginAtBegin && this.$store.state.routeFrom != null && this.$store.state.routeFrom.name != null;
    },
  },

  methods: {
    async login() {
      let phoneID = "+1" + this.phone.replace(/\D+/g, "");

      let lastLogin = {
        name: "",
        phone1: phoneID.substring(2),
        isMember: true,
      };

      this.refreshing = true;

      let isVerifiedPhoneNumber = await this.isVerifiedPhoneNumber(phoneID);

      if (!isVerifiedPhoneNumber) {
        isVerifiedPhoneNumber = await this.$root.phoneVerificationDialog(phoneID);
        if (isVerifiedPhoneNumber) {
          this.addVerifiedPhoneNumber(phoneID);
        }
      }

      if (isVerifiedPhoneNumber) {
        console.log("getting member");

        let res_getMember = await this.rest_getMember(phoneID);
        if (res_getMember.result == "ok") {
          this.$store.state.member = res_getMember.record.child;
          this.setLastLogin(lastLogin);
          this.updateOrderLogin(true);

          let gotoNext = true;
          if (res_getMember.new || this.$store.state.member.MemberFirstName == "") {
            let result_mpd = await this.$root.memberProfileDialog(this.$store.state.member);
            if (result_mpd) {
              let res_getMember2 = await this.rest_getMember(phoneID);
              gotoNext = res_getMember2.result == "ok";
            }
          }

          if (gotoNext) {
            if (this.$loginAtBegin) this.$router.replace(this.$store.state.rootName);
            else if (this.nextRouteName == null) {
              if (this.$store.state.routeFrom == null || this.$store.state.routeFrom.name == null)
                this.$router.replace(this.$store.state.rootName);
              else this.navBack();
            } else this.$router.replace(this.nextRouteName);
          }
        } else {
          this.$root.messageDialog(this.$t("error_alert_title"), "", res_getMember.result);
        }
      } else {
        //
      }

      this.refreshing = false;
    },

    openMRSWebPage() {
      window.open("https://www.mrsdigi.com");
    },
  },
};
</script>

<style lang="scss" scoped>
.login-button {
  margin-top: 24px;
  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}

.theme--light.v-btn.v-btn--disabled.login-button {
  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}

.v-footer {
  padding-bottom: calc(env(safe-area-inset-bottom));

  .powered-by-mrs {
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    .powered-by {
      font-size: 0.8em;
      padding-right: 4px;
      padding-bottom: 4px;
    }
  }
}
</style>
